import {Component, OnInit, OnDestroy} from "@angular/core";
import {BusinessService} from "../../../services/data/business.service";
import {FamilyAlbum} from "../../../model/family-album";
import {Router, ActivatedRoute} from "@angular/router";
import {UrlService} from "../../../services/url.service";
import {Picture} from "../../../model/picture";
import {Page} from "../../../model/page";
import {CurrentEventService} from "../../../services/communication/currentEventService";
import {UploadService} from "../../../services/uploadService";
import {User} from "../../../model/user";
import {UserService} from "../../../services/data/user.service";
import {CommentService} from "../../../services/data/comment.service";
import {Comment} from "../../../model/comment";
import {PhotoSwipeService} from "../../photoswipe/photo-swipe.service";
import {NotificationsService} from "angular2-notifications/components";
import {BusinessRight} from "../../../model/business-right";
import {AuthentService} from "../../../services/authent.service";
import {DateFormatter} from "../../../model/date-formatter";
import {PictureDetailService} from "../picture-detail/picture-detail.service";
import {Business} from "../../../model/business";
import {CurrentBusinessService} from "../../../services/communication/currentBusinessService";
import {ConfigurationService} from "../../../services/configuration.service";
import {FileUploaderService} from "../../../services/communication/fileUploaderService";
import {Subscription} from "rxjs";
import {Tweet} from "../../../model/social/tweet";
import {Media} from "../../../model/social/media";
import {TweetService} from "../../../services/data/tweet.service";

declare const $: any;
declare const document: any;

@Component({
  selector: 'event-detail',
  template: require('./event-detail.component.html'),
  styles: [
    require('./event-detail.component.scss')
  ]
})

export class EventDetailComponent implements OnInit, OnDestroy {

  PAGE_SIZE: number = 25;

  /* Menu */
  showOption: boolean = false;

  model: FamilyAlbum;
  eventId: number;
  currentEvent: FamilyAlbum;
  premiumText: string = 'Premium - Événement Gratuit';

  activeTab: string = 'photos';

  isLoadingPicture: boolean = false;

  picturesModel: Picture[] = new Array<Picture>();
  picturePage: Page<Picture> = null;
  picturePageNumber = 0;

  isLoadingTweet: boolean = false;

  tweetsModel: Tweet[] = new Array<Tweet>();
  tweetPage: Page<Tweet> = null;
  tweetPageNumber = 0;

  removeTweet: Tweet;

  isLoadingUser: boolean = false;

  members: User[] = new Array<User>();
  emails: string = "";

  isLoadingComment: boolean = false;

  comments: Comment[] = new Array<Comment>();
  commentPage: Page<Comment> = null;
  commentPageNumber: number = 0;

  pictureToDelete: number;
  memberToDelete: User = new User();
  commentToDelete: Comment = new Comment();

  userRight: BusinessRight;

  coverHeight: number;
  topMinified: boolean = false;
  topMinimum: boolean = false;

  /** Edition form **/
  editModel: FamilyAlbum = new FamilyAlbum();
  submitted = false;

  inputDate: string = "";

  date: number;
  isPublic: boolean = false;
  isDateValid: boolean = true;

  myDatePickerOptions = {
    todayBtnTxt: 'Aujourd\'hui',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    inline: false,
    locale: 'fr',
    dateFormat: 'dd/mm/yyyy',
    selectionTxtFontSize: '16px'
  };

  /** Show option on picture **/
  showedOption: number = -1;

  coverToSet: number;

  business: Business = new Business();

  publicLink: string;
  embeddedCode: string;
  personalLink: string;

  oldMembers: User[] = [];
  oldMembersPage: number = 1;
  oldMembersLast: boolean = false;
  oldMembersLoading: boolean = false;
  oldSelectAll: boolean = false;

  selecting: boolean = false;

  selected = $([]);

  offset = {top: 0, left: 0};

  private businessSubscription: Subscription = null;
  private swipeSubscription: Subscription = null;
  private rightSubscription: Subscription = null;
  private paramSubscription: Subscription = null;
  private uploadSubscription: Subscription = null;

  ngOnDestroy(): void {
    this.businessSubscription.unsubscribe();
    this.swipeSubscription.unsubscribe();
    if (this.rightSubscription != null) {
      this.rightSubscription.unsubscribe();
    }
    this.paramSubscription.unsubscribe();
    this.uploadSubscription.unsubscribe();
  }

  ngOnInit() {
    this.paramSubscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        this.eventId = param['eventId'];

        if (this.currentEventService.currentEvent != null) {
          this.eventLoaded(this.currentEventService.currentEvent);
        } else {
          this.businessService.getEvent(this.eventId).subscribe(
            event => this.eventLoaded(event)
          );
        }

        this.loadPictures(1);
      });

    this.uploadSubscription = this.fileUploaderService.reloadChanged$.subscribe(
      state => {
        this.loadPictures(1);
      }
    );

    this.loadTweets(1);
  }

  ngAfterViewInit() {
  }

  constructor(private businessService: BusinessService, private router: Router,
              private urlService: UrlService, private activatedRoute: ActivatedRoute,
              private currentEventService: CurrentEventService,
              private uploadService: UploadService, private authent: AuthentService,
              private userService: UserService, private commentService: CommentService,
              private photoSwipeService: PhotoSwipeService, private notificationService: NotificationsService,
              private pictureDetailService: PictureDetailService, private currentBusinessService: CurrentBusinessService,
              private configuration: ConfigurationService, private fileUploaderService: FileUploaderService,
              private tweetService: TweetService) {

    if (authent.getRight() == null) {
      this.rightSubscription = authent.userRight$.subscribe(
        right => {
          this.userRight = right;
        }
      );
    } else {
      this.userRight = authent.getRight();
    }

    this.swipeSubscription = photoSwipeService.pictureChange$.subscribe(
      state => {
        if (state == 'afterChange') {
          this.onScroll();
        }

        if (state == 'closed') {
          this.closeViewer();
        }
      }
    );

    this.bindPageScroll();

    if (currentBusinessService.currentBusiness.logoPath != null) {
      this.business = currentBusinessService.currentBusiness;
    }

    this.businessSubscription = currentBusinessService.businessChange$.subscribe(business => this.business = business);

    $('body').off('focus', '.input-embedded-code').on('focus', '.input-embedded-code', function () {
      $(this).select();
    });
  }

  showUpload() {
    this.uploadService.changeShow(true);
  }

  activateTab(tabName: string) {
    if (tabName == 'comments') {
      this.loadComments(1);
    }
    if (tabName == 'tweets') {
      this.loadTweets(1);
    }

    if (tabName == 'members') {
      this.loadUsers();
    }

    this.activeTab = tabName;
  }

  eventLoaded(event: FamilyAlbum) {
    this.personalLink = this.configuration.getFamiliesUrl() + '/app/#/index/' + this.authent.getToken();
    let publicName = event.name.replace(/#/g, '').split(' ').join('-');
    publicName = publicName.replace(/\//g, '');
    publicName = publicName.replace(/\+/g, '');
    this.publicLink = this.configuration.getFamiliesPublicUrl() + '/event/' + event.id + '/' + publicName;
    let embeddedUrl = this.configuration.getFamiliesPublicUrl() + '/embedded/' + event.id + '/' + publicName;

    this.embeddedCode = '<iframe src="' + embeddedUrl + '" width="450" height="390" allowfullscreen frameborder="0"></iframe>';

    this.currentEventService.changeEvent(event);
    this.currentEvent = this.currentEventService.currentEvent;
    this.editModel = JSON.parse(JSON.stringify(event));
    this.inputDate = DateFormatter.format(this.editModel.date);
    this.date = this.editModel.date;

    this.activatedRoute.queryParams.subscribe(
      (param: any) => {
        let action = param['a'];

        if (action != null && action == 'c') {
          let that = this;

          setTimeout(function () {
            that.openPremiumModal();
          }, 100);
        }
      }
    );

    if (event.premiumType == null || event.premiumType == '') {
      this.currentEvent.premiumType = '';
    }

    if (event.premiumType == 'bronze' || (this.business.premium != null && this.business.premium.type == 'BUSINESS_BRONZE')) {
      this.premiumText = 'Premium - Événement Bronze';
    }

    if (event.premiumType == 'silver' || (this.business.premium != null && this.business.premium.type == 'BUSINESS_SILVER')) {
      this.premiumText = 'Premium - Événement Silver';
    }

    if (event.premiumType == 'gold' || (this.business.premium != null && this.business.premium.type == 'BUSINESS_GOLD')) {
      this.premiumText = 'Premium - Événement Gold';
    }
  }

  openPremiumModal() {
    $('.name').trigger('click');
  }

  setPictureToDelete(pictureId: number, event) {
    event.stopPropagation();
    this.pictureToDelete = pictureId;
    this.pageClick();
  }

  showOptions(event, pictureId: number) {
    event.stopPropagation();
    if (this.showedOption == pictureId) {
      this.pageClick();
    } else {
      this.showedOption = pictureId;
    }
  }

  pageClick() {
    this.showedOption = -1;
  }

  changeCoverToSet(pictureId: number) {
    this.coverToSet = pictureId;
  }

  changeCover() {
    this.businessService.updateCover(this.currentEvent.id, this.coverToSet).subscribe(
      event => {
        this.currentEventService.changeEvent(event);
        this.currentEvent = this.currentEventService.currentEvent;
        this.pageClick();
      }
    )
  }

  setMemberToDelete(member: User) {
    this.memberToDelete = member;
  }

  setCommentToDelete(comment: Comment, event) {
    event.stopPropagation();
    this.commentToDelete = comment;
  }

  edit() {
    this.uploadService.changeShow(false);
    this.router.navigateByUrl('/event/' + this.currentEvent.id + '/edit');
  }

  loadPictures(page?: number) {
    this.isLoadingPicture = true;

    if (page == null) {
      this.picturePageNumber++;
    } else {
      this.picturePageNumber = page;
    }

    this.businessService.eventPictures(this.eventId, this.picturePageNumber, this.PAGE_SIZE).subscribe(
      page => this.picturesLoaded(page)
    );
  }

  loadTweets(page?: number) {
    this.isLoadingTweet = true;

    if (page == null) {
      this.tweetPageNumber++;
    } else {
      this.tweetPageNumber = page;
    }

    this.businessService.eventTweets(this.eventId, this.tweetPageNumber, this.PAGE_SIZE).subscribe(
      page => this.tweetsLoaded(page)
    );
  }

  loadUsers() {
    if (!this.isLoadingUser) {
      this.isLoadingUser = true;

      this.members = new Array<User>();

      this.userService.getEventMembers(this.eventId).subscribe(
        members => this.membersLoaded(members)
      );
    }
  }

  loadComments(page?: number) {
    if (this.activeTab=='comments' && !this.isLoadingComment && (this.commentPage == null || (this.commentPage != null && !this.commentPage.last))) {
      this.isLoadingComment = true;

      if (page == null) {
        this.commentPageNumber++;
      } else {
        this.commentPageNumber = page;
      }

      this.commentService.getEventComments(this.eventId, this.commentPageNumber, this.PAGE_SIZE).subscribe(
        comments => this.commentsLoaded(comments)
      );
    }
  }

  onScroll() {
    if (this.activeTab=='photos' && !this.isLoadingPicture && !this.picturePage != null && !this.picturePage.last) {
      this.loadPictures();
    }
  }

  onTweetScroll() {
    if (this.activeTab=='tweets' && !this.isLoadingTweet && !this.tweetPage != null && !this.tweetPage.last) {
      this.loadTweets();
    }
  }

  back() {
    this.uploadService.changeShow(false);
    this.router.navigateByUrl('/home/events');
    this.currentEventService.changeEvent(null);
  }

  picturesLoaded(page: Page<Picture>) {
    this.picturePage = page;

    if (this.picturePageNumber == 1) {
      this.picturesModel = new Array<Picture>();
    }

    for (let picture of page.content) {
      picture.miniatureUrl = this.urlService.getPictureMiniatureUrl(this.eventId, picture.id);
      picture.url = this.urlService.getPictureUrl(this.eventId, picture.id);
      picture.downloadUrl = this.urlService.getDownloadPictureUrl(picture.id);
      if (picture.owner != null) {
        picture.owner.avatarUrl = this.urlService.getMemberAvatarUrl(picture.owner.id);
      }

      this.picturesModel.push(picture);
    }

    if (this.picturePageNumber > 1) {
      this.photoSwipeService.addPictures(page.content);
    }

    this.isLoadingPicture = false;
  }

  tweetsLoaded(page: Page<Tweet>) {
    this.tweetPage = page;

    if (this.tweetPageNumber == 1) {
      this.tweetsModel = new Array<Tweet>();
    }

    for (let tweet of page.content) {
      tweet.description = tweet.description.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');

      for (let media of tweet.medias) {
        media.miniatureUrl = media.url;
      }

      this.tweetsModel.push(tweet);
    }

    this.isLoadingTweet = false;
  }

  openTweet(medias: Array<Media>, index: number) {
    let pictures = new Array<Picture>();

    for (let media of medias) {
      let picture = new Picture();
      picture.url = media.url;
      picture.miniatureUrl = media.url;
      picture.height = media.height;
      picture.width = media.width;

      pictures.push(picture);
    }

    this.photoSwipeService.openGallery(pictures, false, index);
  }

  setTweetToRemove(tweet) {
    this.removeTweet = tweet;
  }

  doRemoveTweet() {
    this.tweetService.deleteTweet(this.currentEvent.id, this.removeTweet.id).subscribe(
      callback => {
        this.removeTweet = null;
        this.loadTweets(1);
      }
    );
  }

  openPicture(index: number) {
    this.photoSwipeService.openGallery(this.picturesModel, true, index);
    this.pictureDetailService.openDetail(this.picturesModel[index]);
  }

  commentsLoaded(page: Page<Comment>) {
    this.commentPage = page;
    this.currentEvent.nbComments = page.totalElements;

    if (this.commentPageNumber == 1) {
      this.comments = new Array<Comment>();
    }

    for (let comment of page.content) {
      comment.owner.avatarUrl = this.urlService.getMemberAvatarUrl(comment.owner.id);
      this.comments.push(comment);
    }

    this.isLoadingComment = false;
  }

  membersLoaded(members: User[]) {
    for (let member of members) {
      member.avatarUrl = this.urlService.getMemberAvatarUrl(member.id);

      this.members.push(member);
    }

    this.currentEvent.members = members;
    this.isLoadingUser = false;
  }


  deleteMember() {
    this.businessService.removeMember(this.currentEvent.id, this.memberToDelete.id).subscribe(
      reponse => {
        let index = this.members.map(function (member) {
          return member.id;
        }).indexOf(this.memberToDelete.id);

        this.members.splice(index, 1);

        index = this.currentEvent.members.map(function (member) {
          return member.id;
        }).indexOf(this.memberToDelete.id);

        this.currentEvent.members.splice(index, 1);
      }
    );
  }

  deletePicture() {
    this.businessService.deleteEventPictures(this.eventId, [this.pictureToDelete]).subscribe(
      response => {
        let index = this.picturesModel.map(function (picture) {
          return picture.id;
        }).indexOf(this.pictureToDelete);

        this.picturesModel.splice(index, 1);
        this.picturePage.totalElements--;
      }
    );
  }

  deleteComment() {
    this.commentService.deleteComment(this.currentEvent.id, this.commentToDelete.id).subscribe(
      response => {
        let index = this.comments.map(function (comment) {
          return comment.id;
        }).indexOf(this.commentToDelete.id);

        this.comments.splice(index, 1);
        this.currentEvent.nbComments--;
      }
    );
  }

  commentClick(commentId: number) {
    this.commentService.getPictureFromComment(commentId).subscribe(
      picture => {
        picture.miniatureUrl = this.urlService.getPictureMiniatureUrl(this.currentEvent.id, picture.id);
        picture.url = this.urlService.getPictureUrl(this.currentEvent.id, picture.id);
        picture.owner.avatarUrl = this.urlService.getMemberAvatarUrl(picture.owner.id);
        this.photoSwipeService.openGallery([picture]);
        this.pictureDetailService.openDetail(picture);
      }
    );
  }

  inviteMember() {
    this.businessService.inviteMembers(this.currentEvent.id, this.emails).subscribe(
      errors => {
        if (errors.length == 0) {
          this.notificationService.success('Invitations', 'Vos invitations ont été envoyé');
        } else {
          for (let error of errors) {
            this.notificationService.error('Invitations', error.email + ' : ' + error.message);
          }
        }

        this.loadUsers();
      }
    );

  }

  bindPageScroll() {
    let that = this;

    that.handleTopSize();

    // $(window).scroll(function (event) {
    //   that.handleTopSize();
    // });

    window.addEventListener("scroll", function (event) {
      that.handleTopSize();

      setTimeout(function () {
        that.handleTopSize();
      }, 250);
    });

    $(window).resize(function (event) {
      that.handleTopSize();
    });
  }

  // @HostListener('window:scroll', ['$event'])
  handleTopSize() {
    if ($(window).width() > 760) {
      let scroll = $(window).scrollTop();
      let $topProfile = $('.top-cover');

      this.coverHeight = $(window).height() / 2;
      let width = $(window).height();
      // let maxSize = (width > 768) ? 170 : 150;
      let maxSize = 150;

      let size = this.coverHeight - scroll;

      if (size > maxSize) {
        $topProfile.height(this.coverHeight - scroll);
        this.topMinimum = false;
      } else {
        $topProfile.height(maxSize);
        this.topMinimum = true;
      }

      if (size < (this.coverHeight / 3 * 2)) {
        this.topMinified = true;
      } else {
        this.topMinified = false;
      }
    } else {
      this.topMinified = true;
    }
  }

  onDateChanged(event: any) {
    if (event.formatted != undefined && event.formatted != "") {
      this.isDateValid = true;
      this.date = event.epoc * 1000;
    } else {
      this.isDateValid = false;
    }
  }

  updateEvent() {
    this.editModel.date = this.date;

    this.businessService.updateEvent(this.editModel).subscribe(
      event => {
        this.currentEventService.changeEvent(event);
        this.currentEvent = this.currentEventService.currentEvent;
        this.notificationService.success('Evénement', 'Les modifications ont été appliquées');
      }
    );
  }

  delete() {
    this.businessService.deleteEvent(this.editModel.id).subscribe(
      response => this.router.navigateByUrl('/home/events')
    );
  }

  loadOldMembers(page?: number) {

    if (!this.oldMembersLoading && !this.oldMembersLast) {

      this.oldMembersLoading = true;

      if (page != null) {
        this.oldMembersPage = page;
      }

      if (this.oldMembersPage == 1) {
        this.oldMembers = [];
      }

      this.businessService.loadOldMembers(this.currentBusinessService.currentBusiness.id, this.oldMembersPage, 30).subscribe(
        membersPage => {
          for (let member of membersPage.content) {
            if (member.name == null || member.name == '') {
              member.name = member.email;
            }
            member.avatarUrl = this.urlService.getMemberAvatarUrl(member.id);
            this.oldMembers.push(member);
          }

          this.oldMembersPage++;
          this.oldMembersLoading = false;
        }
      );

    }
  }

  inviteOldMembers() {
    if (!this.oldSelectAll) {
      let memberIds = [];

      for (let member of this.oldMembers) {
        if (member.selected) {
          memberIds.push(member.id);
        }
      }

      this.businessService.inviteOldMembers(this.currentEventService.currentEvent.id, memberIds).subscribe(
        response => {
          this.notificationService.success('Invitations', 'Les invitations ont été envoyées');
          this.loadUsers();
        },
        error => {
          this.notificationService.error('Invitations', 'Vous avez atteint la limite de participants');
          this.loadUsers();
        }
      );
    } else {
      this.inviteAllOldMembers();
    }
  }

  inviteAllOldMembers() {
    this.businessService.inviteAllOldMembers(this.currentEventService.currentEvent.id,
      this.currentBusinessService.currentBusiness.id).subscribe(
      response => {
        this.notificationService.success('Invitations', 'Les invitations ont été envoyées');
        this.loadUsers();
      },
      error => {
        this.notificationService.error('Invitations', 'Vous avez atteint la limite de participants');
        this.loadUsers();
      }
    );
  }

  selectAllOld() {

    this.oldSelectAll = !this.oldSelectAll;

    for (let member of this.oldMembers) {
      if (this.oldSelectAll) {
        member.selected = true;
      } else {
        member.selected = false;
      }
    }
  }

  selectOld(selected: User) {
    for (let member of this.oldMembers) {
      if (member.id == selected.id) {
        member.selected = !member.selected;
      }
    }
  }

  uploadPictures() {
    this.fileUploaderService.upload();
  }

  private closeViewer() {
    this.pictureDetailService.changePicture(null);
  }

  goToPremium(type: string) {
    this.router.navigateByUrl('order/event/' + type);
  }

  openSharePopup() {
    let that = this;
    let deepLink = this.urlService.getEventDeepLinkUrl(this.currentEvent.invitationCode);

    setTimeout(function () {
      $('.share-qr-code').empty().qrcode({
        'size': 150,
        'text': deepLink,
        ecLevel: 'H',
        minversion: 6,
        radius: 0.30
      });
    }, 200);
  }

  openPrint() {
    window.open('#/event/' + this.currentEvent.id + '/print', 'newwindow', 'width=' + screen.width + ', height=' + screen.height);
  }

  optionClick() {
    this.showOption = !this.showOption;
  }

  onClickedOutside(event?: any) {
    this.showOption = false;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/event-detail/event-detail.component.ts